const situations = [
  {
    title: "Struggling with monthly payments",
    text: "If your payments have become difficult, we help you understand what options may be available before things escalate.",
    image:
      "https://public.readdy.ai/ai/img_res/989dcb0dc39ccb4341e600fef80d3a38.jpg",
  },
  {
    title: "Vehicle no longer fits your needs",
    text: "Sometimes your situation changes. We help you explore practical next steps — whether selling, transferring, or something else.",
    image:
      "https://readdy.ai/api/search-image?query=Filipino%20person%20standing%20beside%20their%20ordinary%20everyday%20car%20looking%20thoughtful%20and%20contemplative%20holding%20car%20keys%2C%20outdoor%20soft%20natural%20daylight%2C%20calm%20neutral%20expression%20pondering%20a%20life%20decision%2C%20desaturated%20warm%20pastel%20tones%2C%20authentic%20real%20life%20candid%20moment%20genuine%20not%20staged%20not%20a%20luxury%20vehicle&width=700&height=480&seq=situation-card-car-2&orientation=landscape",
  },
  {
    title: "Need clarity on what to do next",
    text: "We guide you through your options so you can make an informed, confident decision — without the guesswork.",
    image:
      "https://readdy.ai/api/search-image?query=Filipino%20person%20sitting%20across%20from%20a%20helpful%20advisor%20at%20a%20small%20office%20table%2C%20both%20calmly%20looking%20at%20documents%20and%20talking%20through%20options%20together%2C%20warm%20natural%20indoor%20lighting%2C%20collaborative%20and%20supportive%20atmosphere%2C%20soft%20pastel%20desaturated%20tones%2C%20real%20consultation%20moment%20authentic%20Southeast%20Asian%20setting%20trustworthy&width=700&height=480&seq=situation-card-consult-3&orientation=landscape",
  },
];

const gradientStyle = {
  background: "linear-gradient(135deg, #4F7CFF 0%, #7B8CFF 100%)",
};
const gradientHover = {
  background: "linear-gradient(135deg, #3D6AE8 0%, #6B7CE8 100%)",
};

export default function SituationsSection() {
  return (
    <section
      id="situations"
      className="py-20 lg:py-28"
      style={{ backgroundColor: "#FFFFFF" }}
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <p
            className="text-sm font-semibold uppercase tracking-widest"
            style={{ color: "#4F7CFF" }}
          >
            We&apos;ve seen it before
          </p>
          <h2
            className="mt-3 text-3xl font-bold tracking-tight sm:text-4xl"
            style={{ color: "#1E293B" }}
          >
            Common situations we help with
          </h2>
          <p className="mt-4 text-base leading-7" style={{ color: "#475569" }}>
            Whatever stage you&apos;re at — we&apos;ve helped people in similar
            situations. You&apos;re not alone in this.
          </p>
        </div>

        <div className="mt-16 grid gap-8 lg:grid-cols-3">
          {situations.map((s, i) => (
            <div
              key={i}
              className="rounded-xl overflow-hidden flex flex-col"
              style={{
                backgroundColor: "#F8FAFC",
                border: "1px solid #E8EEFF",
              }}
            >
              <div className="w-full h-56 overflow-hidden flex-shrink-0">
                <img
                  src={s.image}
                  alt={s.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 hover:scale-105"
                  style={{ filter: "saturate(0.8) brightness(1.02)" }}
                />
              </div>
              <div className="p-7 flex flex-col flex-1">
                <h3
                  className="text-base font-bold leading-snug mb-3"
                  style={{ color: "#1E293B" }}
                >
                  {s.title}
                </h3>
                <p className="text-sm leading-7" style={{ color: "#475569" }}>
                  {s.text}
                </p>
                <a
                  href="#contact"
                  className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold cursor-pointer whitespace-nowrap"
                  style={{ color: "#4F7CFF" }}
                  onMouseEnter={(e) =>
                    ((e.target as HTMLElement).style.color = "#3D6AE8")
                  }
                  onMouseLeave={(e) =>
                    ((e.target as HTMLElement).style.color = "#4F7CFF")
                  }
                >
                  Get help with this
                  <i className="ri-arrow-right-line text-base" />
                </a>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <a
            href="#contact"
            className="whitespace-nowrap inline-block rounded-lg px-8 py-3.5 text-sm font-semibold text-white transition cursor-pointer"
            style={gradientStyle}
            onMouseEnter={(e) =>
              Object.assign((e.target as HTMLElement).style, gradientHover)
            }
            onMouseLeave={(e) =>
              Object.assign((e.target as HTMLElement).style, gradientStyle)
            }
          >
            Talk to Us About Your Situation
          </a>
        </div>
      </div>
    </section>
  );
}
